export default "__VITE_ASSET__AfIBJHqB__"